/* =========================================================
   SILENCE STORE — Editorial engine
   Nessuna libreria esterna. Compatibile con l'editor temi Shopify.
   ========================================================= */
(function () {
  'use strict';
  if (window.SilenceEd) return;

  var clamp = function (v, a, b) { return v < a ? a : (v > b ? b : v); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* =========================================================
     BORDI STRAPPATI — generati, non disegnati a mano.
     Un generatore pseudo-casuale con seme fisso: il bordo è
     sempre identico a ogni caricamento, ma resta irregolare
     come una vera strappata di carta.
     ========================================================= */
  function seeded(seed) {
    return function () { seed = (seed * 1664525 + 1013904223) % 4294967296; return seed / 4294967296; };
  }

  /* trasforma una lista di punti in un path morbido (curve quadratiche) */
  function smooth(pts, closeTo) {
    var d = 'M' + closeTo[0] + ',' + closeTo[1] + ' L' + pts[0][0].toFixed(4) + ',' + pts[0][1].toFixed(4) + ' ';
    for (var i = 1; i < pts.length; i++) {
      var x0 = pts[i - 1][0], y0 = pts[i - 1][1], x1 = pts[i][0], y1 = pts[i][1];
      var mx = (x0 + x1) / 2, my = (y0 + y1) / 2;
      d += 'Q' + x0.toFixed(4) + ',' + my.toFixed(4) + ' ' + mx.toFixed(4) + ',' + my.toFixed(4) + ' ';
      d += 'Q' + x1.toFixed(4) + ',' + my.toFixed(4) + ' ' + x1.toFixed(4) + ',' + y1.toFixed(4) + ' ';
    }
    return d;
  }

  /* bordo verticale: tiene la parte sinistra, strappa lungo x≈center */
  function vertPoints(center, amp, n, seed, lo, hi) {
    var r = seeded(seed), pts = [];
    for (var i = 0; i <= n; i++) {
      var j = (r() * 2 - 1) * amp;
      if (r() < 0.18) j *= 1.9;
      pts.push([clamp(center + j, lo, hi), i / n]);
    }
    return pts;
  }
  function vertPath(pts) { return smooth(pts, [0, 0]) + 'L0,1 Z'; }
  function shiftX(pts, dx, hi) {
    return pts.map(function (p) { return [Math.min(hi, p[0] + dx), p[1]]; });
  }

  /* bordo orizzontale: tiene la parte alta, strappa lungo y≈base */
  function horizPath(base, amp, n, seed, lo, hi) {
    var r = seeded(seed), pts = [];
    for (var i = 0; i <= n; i++) {
      var j = (r() * 2 - 1) * amp;
      if (r() < 0.2) j *= 1.6;
      pts.push([i / n, clamp(base + j, lo, hi)]);
    }
    var d = 'M0,0 L1,0 L1,' + pts[pts.length - 1][1].toFixed(4) + ' ';
    for (var i2 = pts.length - 2; i2 >= 0; i2--) {
      var x0 = pts[i2 + 1][0], y0 = pts[i2 + 1][1], x1 = pts[i2][0], y1 = pts[i2][1];
      var mx = (x0 + x1) / 2, my = (y0 + y1) / 2;
      d += 'Q' + mx.toFixed(4) + ',' + y0.toFixed(4) + ' ' + mx.toFixed(4) + ',' + my.toFixed(4) + ' ';
      d += 'Q' + mx.toFixed(4) + ',' + y1.toFixed(4) + ' ' + x1.toFixed(4) + ',' + y1.toFixed(4) + ' ';
    }
    return d + 'Z';
  }

  var BLOB = 'M0.005,0.47 C0.07,0.19 0.24,-0.02 0.38,0.05 C0.44,0.08 0.48,0.16 0.5,0.19 ' +
             'C0.53,0.12 0.58,0.02 0.66,0.01 C0.83,-0.02 0.98,0.24 1,0.45 ' +
             'C0.96,0.62 0.82,0.83 0.66,0.94 C0.56,1.01 0.43,1.01 0.33,0.95 ' +
             'C0.17,0.85 0.05,0.66 0.005,0.47 Z';

  function ensureDefs() {
    if (document.getElementById('se-defs')) return;

    var vp = vertPoints(0.50, 0.020, 34, 20260820, 0.40, 0.62);
    var clips = [
      ['seTornV', vertPath(vp)],
      ['seTornVwide', vertPath(shiftX(vp, 0.012, 0.66))],
      ['seTornVfull', vertPath(vertPoints(0.968, 0.028, 30, 77345, 0.930, 1))],
      ['seTornH', horizPath(0.70, 0.18, 20, 4412, 0.42, 0.97)],
      ['seBlob', BLOB]
    ].map(function (c) {
      return '<clipPath id="' + c[0] + '" clipPathUnits="objectBoundingBox"><path d="' + c[1] + '"/></clipPath>';
    }).join('');

    var filter =
      '<filter id="seSpray" x="-20%" y="-40%" width="140%" height="180%">' +
        '<feTurbulence type="fractalNoise" baseFrequency="0.045 0.06" numOctaves="3" seed="7" result="n"/>' +
        '<feDisplacementMap in="SourceGraphic" in2="n" scale="9" xChannelSelector="R" yChannelSelector="G" result="d"/>' +
        '<feGaussianBlur in="d" stdDeviation="0.7" result="b"/>' +
        '<feComponentTransfer in="b"><feFuncA type="linear" slope="1.25" intercept="-0.06"/></feComponentTransfer>' +
      '</filter>';

    var wrap = document.createElement('div');
    wrap.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
    wrap.innerHTML = '<svg id="se-defs" width="0" height="0" aria-hidden="true" focusable="false"><defs>' + clips + filter + '</defs></svg>';
    document.body.insertBefore(wrap, document.body.firstChild);
  }

  /* =========================================================
     MOTORE
     ========================================================= */
  var jobs = [];   // funzioni chiamate a ogni frame
  var rails = [];  // caroselli trascinabili
  var running = false;

  function frame() {
    var i;
    for (i = 0; i < jobs.length; i++) { try { jobs[i](); } catch (e) {} }
    for (i = 0; i < rails.length; i++) { try { rails[i].step(); } catch (e) {} }
    /* ognuno nel suo try: un errore in uno non deve fermare tutto il resto */
    try { revealStep(); } catch (e) {}
    try { videoStep(); } catch (e) {}
    try { cursorStep(); } catch (e) {}
    requestAnimationFrame(frame);
  }
  function start() { if (!running) { running = true; requestAnimationFrame(frame); } }

  /* ---------- comparse ----------
     Niente IntersectionObserver: su pagine molto lunghe e con molte
     sezioni le sue callback a volte non venivano consegnate e il
     titolo restava a meta'. Un controllo diretto dentro il loop e'
     una riga di calcolo in piu' per frame ed e' sempre affidabile.
     Ogni elemento esce dalla lista appena comparso. */
  var reveals = [];
  function observe(el) {
    if (!el || el._seRev) return;
    el._seRev = true;
    reveals.push(el);
  }
  function revealStep() {
    var vh = window.innerHeight;
    for (var i = reveals.length - 1; i >= 0; i--) {
      var el = reveals[i];
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) {
        el.classList.add('se-in');
        reveals.splice(i, 1);
      }
    }
  }

  /* ---------- video: partono solo quando si vedono ---------- */
  var vids = [];
  function observeVideo(v) { if (v && vids.indexOf(v) < 0) vids.push(v); }
  function videoStep() {
    var vh = window.innerHeight;
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i], r = v.getBoundingClientRect();
      var inView = r.top < vh && r.bottom > 0;
      if (inView && v.paused) {
        v.preload = 'auto';
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {});
      } else if (!inView && !v.paused) { v.pause(); }
    }
  }

  /* ---------- cursore "[ trascina · clicca ]" ---------- */
  var cur = null, cx = 0, cy = 0, tx = 0, ty = 0;
  function ensureCursor() {
    if (cur) return cur;
    cur = document.createElement('div');
    cur.className = 'se-cursor';
    cur.innerHTML = '<i>[</i><span></span><span></span><i>]</i>';
    document.body.appendChild(cur);
    window.addEventListener('pointermove', function (e) { tx = e.clientX; ty = e.clientY; }, { passive: true });
    return cur;
  }
  function cursorStep() {
    if (!cur) return;
    cx += (tx - cx) * 0.18; cy += (ty - cy) * 0.18;
    cur.style.left = cx.toFixed(1) + 'px';
    cur.style.top = cy.toFixed(1) + 'px';
  }
  function bindCursor(zone, a, b) {
    var c = ensureCursor();
    zone.addEventListener('pointerenter', function () {
      var sp = c.querySelectorAll('span');
      sp[0].textContent = a || 'Trascina';
      sp[1].textContent = b || 'Clicca';
      c.classList.add('is-on');
    });
    zone.addEventListener('pointerleave', function () { c.classList.remove('is-on'); });
  }

  /* ---------- carosello trascinabile ---------- */
  function makeRail(track, zone, opts) {
    opts = opts || {};
    var st = { x: 0, v: 0, down: false, sx: 0, s0: 0, min: 0, loopW: 0, auto: opts.auto || 0, moved: 0 };

    function bounds() {
      var vw = zone.getBoundingClientRect().width;
      /* La corsia ha un rientro a sinistra (34rem su computer) dove stanno le
         scritte laterali. Senza toglierlo dal conto il carosello si ferma
         troppo presto e l'ultimo capo resta tagliato fuori dallo schermo. */
      var padL = parseFloat(getComputedStyle(zone).paddingLeft) || 0;
      st.loopW = opts.loop ? track.scrollWidth / 2 : 0;
      st.min = opts.loop ? -Infinity : Math.min(0, vw - padL - track.scrollWidth - (opts.padRight || 0));
      /* Serve alla barra di avanzamento: quanto e' larga la fila per intero e
         quanta se ne vede adesso. Si calcola qui e non a ogni fotogramma,
         perche' leggere scrollWidth costringe il browser a rifare i conti
         della pagina ed e' la cosa piu' cara che possiamo fare in un'animazione. */
      st.view = Math.max(1, vw - padL);
      st.content = Math.max(1, track.scrollWidth);
    }
    bounds();
    window.addEventListener('resize', bounds);
    setTimeout(bounds, 1200);

    zone.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      st.down = true; st.sx = e.clientX; st.s0 = st.x; st.v = 0; st.moved = 0;
      st.pid = e.pointerId; st.cap = false;
    });
    zone.addEventListener('pointermove', function (e) {
      if (!st.down) return;
      var d = e.clientX - st.sx;
      if (Math.abs(d) > st.moved) st.moved = Math.abs(d);
      /* LA CATTURA DEL PUNTATORE SI PRENDE SOLO QUANDO SI TRASCINA DAVVERO.
         Prima si prendeva subito, al primo tocco. Ma quando un elemento ha la
         cattura, il browser manda A QUELL'ELEMENTO anche il click finale: il
         click arrivava alla corsia invece che al capo, e il prodotto non si
         apriva. Provato dal vivo: togliendo la cattura, lo stesso identico
         clic apre la scheda.
         Serve comunque, per continuare a trascinare anche col dito uscito
         dalla corsia: la prendiamo appena il gesto e' una trascinata vera. */
      if (!st.cap && st.moved > 12) {
        st.cap = true;
        try { zone.setPointerCapture(e.pointerId); } catch (err) {}
      }
      var nx = st.s0 + d;
      st.v = nx - st.x;
      st.x = opts.loop ? nx : clamp(nx, st.min, 0);
    });
    function up() {
      st.down = false;
      if (st.cap) {
        st.cap = false;
        try { zone.releasePointerCapture(st.pid); } catch (err) {}
      }
    }
    zone.addEventListener('pointerup', up);
    zone.addEventListener('pointercancel', up);
    zone.addEventListener('pointerleave', up);
    /* Dopo un TRASCINAMENTO non si apre il link. Ma la soglia era 6 pixel:
       giusta per il mouse, troppo stretta per un dito. Un tocco sul telefono
       scivola facilmente di 7-10 pixel, quindi il capo non si apriva: il click
       veniva scambiato per una trascinata. Il browser stesso usa una tolleranza
       di 8-10 pixel per distinguere un tocco da un trascinamento.
       La distanza si azzera subito dopo il controllo: restava sporca dal gesto
       precedente e bloccava anche il tocco successivo. */
    zone.addEventListener('click', function (e) {
      var trascinato = st.moved > 12;
      st.moved = 0;
      if (trascinato) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    zone.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        st.x = opts.loop ? st.x - e.deltaX : clamp(st.x - e.deltaX, st.min, 0);
      }
    }, { passive: false });

    st.step = function () {
      if (!st.down) {
        st.v *= 0.93;
        if (Math.abs(st.v) > 0.05) st.x = opts.loop ? st.x + st.v : clamp(st.x + st.v, st.min, 0);
        if (st.auto && !reduce) st.x -= st.auto;
      }
      if (opts.loop && st.loopW) {
        if (st.x <= -st.loopW) st.x += st.loopW;
        if (st.x > 0) st.x -= st.loopW;
      }
      track.style.transform = 'translate3d(' + st.x.toFixed(2) + 'px,0,0)';
    };
    rails.push(st);
    return st;
  }

  /* =========================================================
     SEZIONI
     ========================================================= */
  function initHero(root) {
    var media = root.querySelector('[data-se-hero-media]');
    var zoom = root.querySelector('[data-se-hero-zoom]');
    var title = root.querySelector('[data-se-hero-title]');
    var sub = root.querySelector('[data-se-hero-sub]');
    var marq = root.querySelector('[data-se-hero-marq]');
    var row = marq ? marq.querySelector('.se-marqrow') : null;
    var slides = root.querySelectorAll('.se-hero__slide');
    var speed = parseFloat(root.getAttribute('data-se-marq-speed') || '0.9');
    var delay = parseInt(root.getAttribute('data-se-slide-delay') || '4800', 10);
    var mx = 0, si = 0;
    var box = root.querySelector('.se-hero');

    /* l'hero sta sotto l'header del tema: gli tolgo quello spazio
       cosi' resta comunque tutto dentro la prima schermata */
    function fitHero() {
      if (!box) return;
      var pct = parseFloat(root.getAttribute('data-se-height') || '100') / 100;
      var off = box.getBoundingClientRect().top + window.scrollY;
      var h = window.innerHeight * pct - Math.min(off, window.innerHeight * 0.45);
      box.style.height = Math.max(window.innerHeight * 0.5, h) + 'px';
    }
    fitHero();
    window.addEventListener('resize', fitHero);
    setTimeout(fitHero, 900);

    root.querySelectorAll('.se-mask').forEach(function (m) {
      setTimeout(function () { m.classList.add('se-in'); }, 150);
    });

    if (slides.length > 1 && !reduce) {
      root._seTimer = setInterval(function () {
        slides[si].classList.remove('is-on');
        si = (si + 1) % slides.length;
        slides[si].classList.add('is-on');
      }, delay);
    }

    jobs.push(function () {
      var r = root.getBoundingClientRect();
      var p = clamp(-r.top / (window.innerHeight * 0.85), 0, 1);
      if (media) media.style.clipPath = 'inset(' + (p * 16).toFixed(2) + '% 0% 0% ' + (p * 42).toFixed(2) + '%)';
      if (zoom) zoom.style.transform = 'translate3d(0,' + (p * 6).toFixed(2) + 'vh,0) scale(' + (1 + p * 0.08).toFixed(3) + ')';
      if (title) title.style.transform = 'translate3d(0,' + (p * 26).toFixed(2) + 'vh,0)';
      if (sub) {
        sub.style.transform = 'translate3d(0,' + (p * 22).toFixed(2) + 'vh,0)';
        sub.style.opacity = (1 - p * 0.45).toFixed(3);
      }
      if (marq) marq.style.opacity = (1 - p * 1.6).toFixed(3);
      if (row && !reduce) {
        mx -= speed;
        var half = row.scrollWidth / 2;
        if (half && mx <= -half) mx += half;
        row.style.transform = 'translate3d(' + mx.toFixed(2) + 'px,0,0)';
      }
    });
  }

  function initArrivals(root) {
    var track = root.querySelector('[data-se-rail-track]');
    var zone = root.querySelector('[data-se-rail]');
    if (!track || !zone) return;
    observe(root);
    bindCursor(zone, zone.getAttribute('data-se-cur-a'), zone.getAttribute('data-se-cur-b'));
    var rail = makeRail(track, zone, { padRight: 60 });

    var tagEl = root.querySelector('[data-se-arr-tag]');
    var cards = track.children;
    var side = root.querySelector('.se-arr__side');
    var prog = root.querySelector('[data-se-prog]');
    var progFill = prog ? prog.querySelector('[data-se-prog-fill]') : null;
    var progOff = true;

    /* Da qui in poi comanda il motore: i capi partono nascosti e li scopre
       lui. Senza questa classe (motore rotto o spento) il CSS li mostra
       tutti, cosi' un guasto non lascia mai la fila vuota. */
    zone.classList.add('is-live');

    jobs.push(function () {
      if (!cards.length) return;

      /* Ogni capo esce quando entra davvero in vista, non tutti insieme
         all'arrivo della sezione: chi scorre vede i prodotti comparire. */
      var zr = zone.getBoundingClientRect();
      for (var k = 0; k < cards.length; k++) {
        var c = cards[k];
        if (c.classList.contains('is-in')) continue;
        var r = c.getBoundingClientRect();
        /* Si scopre appena si affaccia dal bordo destro: l'apertura dura
           un secondo, se aspettassi che sia dentro del tutto si vedrebbe
           un riquadro vuoto al bordo mentre scorre. */
        if (r.left < zr.right + 60) c.classList.add('is-in');
      }

      /* BARRA DI AVANZAMENTO.
         rail.min e' il punto piu' a sinistra a cui la fila puo' arrivare (un
         numero negativo): rail.x / rail.min va da 0 (inizio) a 1 (fine).
         La parte piena e' larga quanto la fetta di fila visibile, come la
         barra di scorrimento del browser, e si sposta dentro lo spazio che
         avanza. Se i capi ci stanno tutti nello schermo (min ~ 0) la barra
         non ha niente da dire e resta nascosta. */
      if (progFill) {
        if (rail.min < -8) {
          var q = clamp(rail.x / rail.min, 0, 1);
          var fetta = clamp(rail.view / rail.content, 0.08, 1) * 100;
          progFill.style.width = fetta.toFixed(2) + '%';
          progFill.style.left = (q * (100 - fetta)).toFixed(2) + '%';
          if (progOff) { progOff = false; prog.classList.remove('is-off'); }
        } else if (!progOff) {
          progOff = true;
          prog.classList.add('is-off');
        }
      }

      /* Le scritte laterali si tolgono di mezzo appena si comincia a scorrere. */
      if (side) {
        if (rail.x < -24) side.classList.add('is-via');
        else side.classList.remove('is-via');
      }

      if (tagEl) {
        var w = cards[0].offsetWidth + 12;
        if (!w) return;
        var i = clamp(Math.round(-rail.x / w), 0, cards.length - 1);
        var t = cards[i].getAttribute('data-se-tag');
        if (t && tagEl.textContent !== t) tagEl.textContent = t;
      }
    });
  }

  function initCampaign(root) {
    var wrap = root.querySelector('[data-se-pinwrap]');
    var media = root.querySelector('[data-se-camp-media]');
    var fr = root.querySelector('[data-se-camp-frame]');
    var vid = root.querySelector('video');
    var par = root.querySelector('[data-se-camp-p]');
    var words = [];
    if (par && !par.getAttribute('data-se-split')) {
      par.innerHTML = par.innerHTML.split(' ').map(function (w) { return '<span>' + w + '</span>'; }).join(' ');
      par.setAttribute('data-se-split', '1');
    }
    if (par) words = par.querySelectorAll('span');
    if (vid) observeVideo(vid);

    jobs.push(function () {
      if (!wrap) return;
      var dist = wrap.offsetHeight - window.innerHeight;
      var p = dist > 0 ? clamp(-wrap.getBoundingClientRect().top / dist, 0, 1) : 1;
      var ins = (1 - p) * 12;
      var insx = ins * 1.6;
      if (media) media.style.clipPath = 'inset(' + ins.toFixed(2) + '% ' + insx.toFixed(2) + '% ' + ins.toFixed(2) + '% ' + insx.toFixed(2) + '%)';
      if (vid) vid.style.transform = 'scale(' + (1.14 - p * 0.14).toFixed(3) + ')';
      if (fr) {
        fr.style.top = ins.toFixed(2) + '%';
        fr.style.bottom = ins.toFixed(2) + '%';
        fr.style.left = insx.toFixed(2) + '%';
        fr.style.right = insx.toFixed(2) + '%';
        fr.style.opacity = Math.min(1, p * 2.2).toFixed(2);
      }
      var lit = Math.floor(p * 1.35 * words.length);
      for (var i = 0; i < words.length; i++) {
        if (i < lit) words[i].classList.add('is-lit'); else words[i].classList.remove('is-lit');
      }
    });
  }

  function initCategories(root) {
    var track = root.querySelector('[data-se-cats-track]');
    if (!track) return;
    observe(root);
    bindCursor(root, root.getAttribute('data-se-cur-a'), root.getAttribute('data-se-cur-b'));
    makeRail(track, root, { loop: true, auto: parseFloat(root.getAttribute('data-se-auto') || '0.55') });
  }

  function initSplit(root) { observe(root); }

  function initBold(root) {
    var spray = root.querySelector('[data-se-spray]');
    var fig = root.querySelector('[data-se-bold-fig]');
    jobs.push(function () {
      var r = root.getBoundingClientRect();
      var vh = window.innerHeight;
      var p = clamp((vh - r.top) / (vh + r.height), 0, 1);
      if (spray) spray.style.transform = 'translate3d(0,' + ((0.5 - p) * 10).toFixed(2) + 'vh,0) scale(' + (1 + p * 0.06).toFixed(3) + ')';
      if (fig) fig.style.transform = 'translate3d(0,' + ((0.5 - p) * -6).toFixed(2) + 'vh,0)';
    });
  }

  function initFilm(root) {
    var wrap = root.querySelector('[data-se-pinwrap]');
    var blob = root.querySelector('[data-se-blob]');
    var tip = root.querySelector('[data-se-tip]');
    var head = root.querySelector('.se-film__head');
    var vid = root.querySelector('video');
    var grow = parseFloat(root.getAttribute('data-se-grow') || '4.2');
    if (head) observe(head);
    if (vid) observeVideo(vid);

    jobs.push(function () {
      if (!wrap) return;
      var dist = wrap.offsetHeight - window.innerHeight;
      var p = dist > 0 ? clamp(-wrap.getBoundingClientRect().top / dist, 0, 1) : 0;
      if (blob) blob.style.transform = 'translate(-50%,-50%) scale(' + (1 + p * grow).toFixed(3) + ') rotate(' + (p * 4).toFixed(2) + 'deg)';
      if (tip) tip.style.opacity = (1 - p * 2.2).toFixed(3);
      if (head) head.style.opacity = clamp(1 - p * 1.6, 0, 1).toFixed(3);
    });
  }


  /* ---------- barra servizi ---------- */
  function initServices(root) {
    var row = root.querySelector('[data-se-serv-row]');
    if (!row) return;
    var speed = parseFloat(root.getAttribute('data-se-speed') || '0.5');
    var x = 0;
    jobs.push(function () {
      if (reduce) return;
      x -= speed;
      var half = row.scrollWidth / 2;
      if (half && x <= -half) x += half;
      row.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
    });
  }

  /* ---------- banda pagamenti ---------- */
  function initPayments(root) {
    observe(root);
    root.querySelectorAll('.se-mask').forEach(observe);
  }

  /* ---------- banner collezione ---------- */
  function initBanner(root) {
    observe(root);
    root.querySelectorAll('.se-mask').forEach(observe);
    var img = root.querySelector('[data-se-ban-img]');
    if (!img) return;
    var amt = parseFloat(root.getAttribute('data-se-parallax') || '10');
    jobs.push(function () {
      var r = root.getBoundingClientRect();
      var vh = window.innerHeight;
      if (r.bottom < -200 || r.top > vh + 200) return;
      var p = clamp((vh - r.top) / (vh + r.height), 0, 1);
      img.style.transform = 'translate3d(0,' + ((p - 0.5) * -amt).toFixed(2) + '%,0)';
    });
  }

  /* ---------- chi siamo ---------- */
  function initAbout(root) {
    observe(root);
    root.querySelectorAll('.se-mask').forEach(observe);
  }

  /* ---------- recensioni ---------- */
  function initReviews(root) {
    observe(root);
    root.querySelectorAll('.se-mask').forEach(observe);
    var speed = parseFloat(root.getAttribute('data-se-speed') || '0.4');
    root.querySelectorAll('[data-se-rev-row]').forEach(function (zone, i) {
      var track = zone.querySelector('[data-se-rev-track]');
      if (!track) return;
      bindCursor(zone, root.getAttribute('data-se-cur-a'), root.getAttribute('data-se-cur-b'));
      makeRail(track, zone, { loop: true, auto: i % 2 === 0 ? speed : -speed });
    });
    var bg = root.querySelector('[data-se-rev-bg]');
    if (bg) {
      jobs.push(function () {
        var r = root.getBoundingClientRect();
        var vh = window.innerHeight;
        var p = clamp((vh - r.top) / (vh + r.height), 0, 1);
        bg.style.transform = 'translate3d(' + ((0.5 - p) * 14).toFixed(2) + '%,0,0)';
      });
    }
  }

  /* ---------- vieni a trovarci ---------- */
  function initVisit(root) {
    observe(root);
    root.querySelectorAll('.se-mask').forEach(observe);
  }

  var INIT = {
    hero: initHero,
    arrivals: initArrivals,
    campaign: initCampaign,
    categories: initCategories,
    split: initSplit,
    bold: initBold,
    film: initFilm,
    services: initServices,
    payments: initPayments,
    banner: initBanner,
    about: initAbout,
    reviews: initReviews,
    visit: initVisit
  };

  function initAll(scope) {
    ensureDefs();
    (scope || document).querySelectorAll('[data-se-section]').forEach(function (el) {
      if (el._seDone) return;
      el._seDone = true;
      var kind = el.getAttribute('data-se-section');
      if (INIT[kind]) INIT[kind](el);
      el.querySelectorAll('.se-rv').forEach(observe);
    });
    start();
  }

  function rebuild() {
    jobs.length = 0;
    rails.length = 0;
    reveals.length = 0;
    vids.length = 0;
    document.querySelectorAll('[data-se-section]').forEach(function (el) {
      if (el._seTimer) { clearInterval(el._seTimer); el._seTimer = null; }
      el._seDone = false;
    });
    document.querySelectorAll('.se-mask, .se-rv, [data-se-section]').forEach(function (el) { el._seRev = false; });
    initAll(document);
  }

  /* editor temi: ricostruisce quando una sezione viene modificata */
  document.addEventListener('shopify:section:load', rebuild);
  document.addEventListener('shopify:section:unload', rebuild);
  document.addEventListener('shopify:section:reorder', rebuild);

  /* permette a nuove sezioni di agganciarsi al motore senza toccare questo file:
     SilenceEd.register('nome', function (root) { ... }) */
  function register(kind, fn) { INIT[kind] = fn; }

  window.SilenceEd = { init: initAll, rebuild: rebuild, register: register, jobs: jobs, observe: observe };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
})();
